var NoteType;
(function(NoteType) {
    NoteType["NextPayment"] = "nextPayment";
    NoteType["Processing"] = "processing";
    NoteType["Ended"] = "ended";
    NoteType["Paused"] = "paused";
    NoteType["Attention"] = "attention";
    NoteType["Text"] = "text";
})(NoteType || (NoteType = {}));
var PaymentMethod;
(function(PaymentMethod) {
    PaymentMethod["Card"] = "Card";
    PaymentMethod["Paypal"] = "Paypal";
})(PaymentMethod || (PaymentMethod = {}));
function isNextPaymentNote(data) {
    return Boolean((data === null || data === void 0 ? void 0 : data.paymentMethod) && (data === null || data === void 0 ? void 0 : data.date));
}

export { NoteType, PaymentMethod, isNextPaymentNote };
